function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 19.196,
  height: 19.196,
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2.418 0)"
}, React.createElement("path", {
  d: "M13.047,19.2H1.368A1.361,1.361,0,0,1,0,17.846V1.35A1.361,1.361,0,0,1,1.368,0H7.835A1.375,1.375,0,0,1,8.38.116L8.4.125l.008,0L8.432.14c.024.012.049.025.081.043A1.456,1.456,0,0,1,8.788.4L14,5.657a1.338,1.338,0,0,1,.382.951V17.846A1.326,1.326,0,0,1,13.047,19.2ZM1.35,1.35v16.5H13.028V7.2H8.548A1.361,1.361,0,0,1,7.18,5.849V1.35Zm7.18.72V5.849h3.764Zm.543,13.677h-6a.675.675,0,1,1,0-1.35h6a.675.675,0,1,1,0,1.35Zm2.4-3h-8.4a.675.675,0,1,1,0-1.35h8.4a.675.675,0,1,1,0,1.35Zm-3.6-3h-4.8a.675.675,0,1,1,0-1.35h4.8a.675.675,0,1,1,0,1.35Z",
  transform: "translate(0 0)",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19.196,
    height: 19.196,
    viewBox: "0 0 19.196 19.196"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/reporting.2cd2875e.svg";
export { SvgComponent as ReactComponent };